<script>
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition';
  import { siteNoticeBinding, siteNoticeShow } from '../../stores/headerMenu.ts';
  
  let { content, closeLabel, link, theme = 'pink', token, dataTestId = 'site-notice' } = $props();

  onMount(() => {
    if (localStorage.getItem(token) === null && sessionStorage.getItem(token) === null) {
      const url = new URL(window.location.href);
      const queryParams = url.searchParams;
      const psi = queryParams.has('psi');

      if (!psi) {
        sessionStorage.setItem(token, true); // Only show notice once per session
        siteNoticeShow.set(true);
      }
    }
  });

  const onClose = () => {
    localStorage.setItem(token, true);
    siteNoticeShow.set(false);
  };

  const onAction = () => {
    if (link.target === 'blank') {
      window.open(link.url, '_blank');
    } else {
      window.location = link.url;
    }
  };
</script>

{#if $siteNoticeShow && content}
  <div
    transition:slide
    data-testid={dataTestId}
    data-token={token}
    bind:this={$siteNoticeBinding}
    class:bg-blue-cerulean={theme === 'blue'}
    class:bg-pink={theme === 'pink'}
  >
    <div class="text-white px-4">
      <div class="max-w-6xl mx-auto py-4 flex flex-col md:flex-row md:justify-between">
        <div class="mb-4 md:mb-0 text-sm items-center markdown-wrapper">
          {@html content}
        </div>
        <div class="flex flex-row justify-around">
          <button class="font-bold text-white hover-hover:hover:underline active:underline mr-4" onclick={onAction}
            >{link.text}</button
          >
          <button class="font-bold text-white hover-hover:hover:underline active:underline ml-4" onclick={onClose}
            >{closeLabel}</button
          >
        </div>
      </div>
    </div>
  </div>
{/if}
